
import { PasswordValidatorComponent } from './password-validator.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { InputTextModule } from 'primeng/inputtext';

@NgModule({
  declarations: [PasswordValidatorComponent],
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, InputTextModule],
  exports: [PasswordValidatorComponent, TranslateModule, InputTextModule]
})
export class PasswordValidatorModule { }


